module.exports = __webpack_public_path__ + "media/images/arrows/long-149f9d0115c627d23e06c6382259f2a4.svg";